var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfidentialite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 244,
    height: 179,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#97A6B7",
    d: "m240.409 107.421-2.783.005a20.15 20.15 0 0 0-1.291-5.302l2.352-1.375c.643-.376.863-1.224.493-1.895l-.989-1.792c-.373-.676-1.2-.924-1.85-.552l-2.324 1.328a20.536 20.536 0 0 0-3.834-4.088l1.336-2.314c.383-.664.156-1.538-.51-1.955l-1.778-1.112c-.673-.42-1.535-.222-1.926.446l-1.34 2.29a20.684 20.684 0 0 0-5.543-1.703v-2.716c0-.8-.654-1.48-1.463-1.518l-2.166-.1c-.82-.037-1.486.589-1.486 1.398v2.746c-2.022.17-3.971.628-5.804 1.337l-1.445-2.483c-.425-.729-1.369-1.012-2.109-.629l-1.98 1.024a1.438 1.438 0 0 0-.573 2.032l1.498 2.54a20.984 20.984 0 0 0-4.347 4.153l-2.709-1.545c-.769-.438-1.755-.21-2.201.51l-1.191 1.923c-.449.726-.183 1.666.594 2.1l2.804 1.563a20.266 20.266 0 0 0-1.531 5.762l-3.363.005c-.906.002-1.641.693-1.641 1.545v2.264c0 .851.736 1.532 1.641 1.521l3.452-.044a20.156 20.156 0 0 0 1.685 5.601l-3.047 1.743c-.777.445-1.043 1.39-.594 2.109l1.191 1.905c.447.714 1.432.927 2.201.479l3.082-1.802a20.62 20.62 0 0 0 4.253 3.832l-1.777 3.038c-.433.74-.176 1.648.573 2.025l1.98.995c.74.372 1.684.076 2.109-.659l1.762-3.051a20.754 20.754 0 0 0 5.487 1.146v3.402c0 .81.667 1.427 1.486 1.377l2.166-.13c.809-.049 1.463-.738 1.463-1.539v-3.364a20.989 20.989 0 0 0 5.248-1.635l1.635 2.772c.391.663 1.253.849 1.926.419l1.778-1.138c.666-.426.893-1.302.51-1.961l-1.588-2.725a21.014 21.014 0 0 0 3.762-3.894l2.647 1.477c.65.362 1.478.102 1.851-.579l.988-1.807c.371-.677.151-1.521-.493-1.888l-2.559-1.459a20.337 20.337 0 0 0 1.423-5.202l2.858-.036c.737-.01 1.332-.637 1.332-1.402v-2.033c0-.764-.596-1.383-1.332-1.382l.001-.003Zm-22.529 16.738c-8.235.307-15.126-6.134-15.126-14.398s6.891-14.793 15.126-14.591c7.955.195 14.207 6.64 14.207 14.403 0 7.762-6.252 14.289-14.207 14.586Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#97A6B7",
    d: "m208.665 87.33-1.982-.07-.683 1.792 2.665-1.722Zm19.654.826 2.286.023v1.7l-2.286-1.723Zm8.711 8.197 2.278.093-.57 1.286-1.708-1.379Zm3.577 11.092 2.3.183-.751 1.125-1.549-1.308Zm-3.828 15.913 2.232.321.274-1.837-2.506 1.516Zm-8.544 8.288 2.005.368.16-1.493-2.165 1.125Zm-10.023 3.583-1.8-.322 1.548-2.319.252 2.641Zm-9.751-1.952-2.097-.436 1.618-1.975.479 2.411Zm-11.779-37.841 2.187.068-.865 1.608-1.322-1.676Zm-4.352 17.29 2.005.299-.159-1.654-1.846 1.355Zm4.307 12.102 1.959.321.159-1.309-2.118.988Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8DEE8",
    d: "m242.658 107.603-2.806.005a20.223 20.223 0 0 0-1.303-5.345l2.373-1.387c.648-.379.87-1.233.497-1.91l-.997-1.807c-.376-.681-1.211-.931-1.866-.557l-2.343 1.34a20.74 20.74 0 0 0-3.866-4.122l1.347-2.333c.387-.67.158-1.55-.513-1.97l-1.793-1.12c-.678-.425-1.548-.224-1.942.449l-1.351 2.308a20.893 20.893 0 0 0-5.589-1.717v-2.738c0-.808-.659-1.493-1.475-1.53l-2.183-.1a1.408 1.408 0 0 0-1.499 1.409v2.769a21.118 21.118 0 0 0-5.852 1.347l-1.458-2.502c-.428-.736-1.38-1.021-2.127-.635l-1.997 1.032a1.45 1.45 0 0 0-.578 2.05l1.511 2.56a21.183 21.183 0 0 0-4.383 4.186l-2.732-1.557c-.774-.442-1.768-.212-2.219.513l-1.2 1.939c-.453.73-.185 1.68.599 2.117l2.826 1.576a20.48 20.48 0 0 0-1.543 5.808l-3.391.006c-.912.002-1.655.699-1.655 1.557v2.282c0 .858.742 1.545 1.655 1.534l3.48-.044a20.256 20.256 0 0 0 1.7 5.647l-3.073 1.757c-.784.448-1.053 1.401-.599 2.125l1.201 1.922c.45.72 1.443.935 2.218.482l3.108-1.816a20.793 20.793 0 0 0 4.288 3.863l-1.792 3.063c-.436.746-.177 1.661.578 2.041l1.997 1.004c.747.375 1.699.076 2.127-.666l1.777-3.075a20.931 20.931 0 0 0 5.534 1.155v3.429c0 .816.671 1.438 1.498 1.389l2.184-.132c.815-.049 1.475-.743 1.475-1.551v-3.392a21.121 21.121 0 0 0 5.29-1.649l1.649 2.794c.393.668 1.263.856 1.942.422l1.793-1.147c.671-.429.9-1.313.514-1.977l-1.601-2.747a21.106 21.106 0 0 0 3.793-3.926l2.669 1.488c.655.365 1.49.103 1.866-.583l.997-1.821c.374-.682.152-1.534-.497-1.904l-2.581-1.471a20.51 20.51 0 0 0 1.436-5.244l2.881-.036c.743-.009 1.343-.641 1.343-1.412v-2.05c0-.771-.6-1.394-1.343-1.393l.001-.002Zm-22.717 16.874c-8.302.311-15.25-6.184-15.25-14.514 0-8.33 6.948-14.914 15.25-14.711 8.021.197 14.326 6.694 14.326 14.52 0 7.825-6.305 14.405-14.326 14.705Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#26264F",
    d: "M242.384 159.489 2.398 157.428v6.1c0 1.655 1.047 3.063 2.464 3.314l67.861 12.013a9.42 9.42 0 0 0 2.435.112l164.618-13.696c1.469-.122 2.608-1.534 2.608-3.236v-2.547.001Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#26264F",
    d: "M155.294 149.713 4.88 160.873c-2.692.2-4.88-1.922-4.88-4.739V43.24c0-2.818 2.188-5.102 4.88-5.102h150.414c2.217 0 4.01 2.065 4.01 4.612v102.054c0 2.547-1.793 4.745-4.01 4.91v-.001Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M157.692 149.713 7.279 160.873c-2.692.2-4.88-1.922-4.88-4.739V43.24c0-2.818 2.188-5.102 4.88-5.102h150.413c2.217 0 4.011 2.065 4.011 4.612v102.054c0 2.547-1.794 4.745-4.011 4.91v-.001Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m153.007 142.518-140.095 9.695c-2.19.152-3.97-1.59-3.97-3.89v-98.84c0-2.3 1.779-4.173 3.97-4.183l140.095-.609c1.829-.007 3.308 1.685 3.308 3.78v90.023c0 2.095-1.479 3.897-3.308 4.023v.001Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M87.797 41.225c0 1.05-.774 1.902-1.73 1.905-.957.003-1.734-.847-1.734-1.898 0-1.05.776-1.904 1.734-1.904.956 0 1.73.85 1.73 1.897Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M163.688 149.094 2.398 160.841l70.325 12.449c.806.143 1.622.18 2.435.113l167.226-13.914-76.131-10.315a12.445 12.445 0 0 0-2.566-.08h.001Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#26264F",
    d: "m25.933 160.942 134.278-9.925 41.558 5.585-133.121 10.61-42.715-6.27Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7EAF5",
    d: "m143.244 93.122-60.215 2.132v-6.137l60.215-1.902v5.907Zm0 9.676-60.215 2.51v-6.137l60.215-2.28v5.907Zm-79.7-8.574-34.576 1.188v-4.587l34.576-1.092v4.491Zm0 7.357-34.576 1.345v-4.587l34.576-1.248v4.49Zm0 7.356-34.576 1.502v-4.587l34.576-1.405v4.49Zm0 7.358-34.576 1.658v-4.586l34.576-1.563v4.491Zm46.094-2.21-26.61 1.276v-6.137l26.61-1.174v6.035Zm-4.286-48.087v9.218c0 2.666 2.225 4.767 4.961 4.696l6.783-.178c2.703-.071 4.887-2.267 4.887-4.904v-9.12l-16.631.29Zm6.248 9.53 1.261-3.85a1.663 1.663 0 0 1-.906-1.48c0-.945.787-1.727 1.757-1.746.969-.019 1.754.732 1.754 1.676 0 .643-.365 1.21-.903 1.514l1.256 3.787-4.219.099Zm8.456-10.618a1.264 1.264 0 0 1-1.303-1.254c0-2.71-2.257-4.884-5.041-4.849-2.792.036-5.072 2.285-5.072 5.011 0 .71-.592 1.294-1.323 1.307-.731.012-1.324-.553-1.324-1.264 0-4.15 3.472-7.565 7.719-7.614 4.225-.048 7.645 3.257 7.645 7.367 0 .703-.582 1.283-1.301 1.295v.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.278 160.874 156.93 149.77l.761-.056c1.017-.075 1.943-.582 2.65-1.351-10.769-.594-17.458-4.446-21.773-8.426-8.666-7.993-7.163-15.875-16.507-21.13-11.655-6.555-20.819 1.751-29.663-6.444-5.362-4.968-2.73-8.673-9.327-16.097-7.308-8.223-12.065-5.459-19.409-12.86-9.285-9.359-4.641-16.639-12.64-23.358-9.704-8.15-20.168-.606-29.405-8.423-3.984-3.371-6.17-8.273-7.311-13.485H7.279c-2.692 0-4.88 2.284-4.88 5.102v112.893c0 2.817 2.188 4.939 4.879 4.74v-.001Z",
    opacity: 0.48,
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M174.519 100.807a10.386 10.386 0 0 1-5.689-1.483c-5.191-3.137-12.863-8.317-19.766-15.099-8.759-8.605-13.79-17.352-14.891-25.941l-.017-.135-.213-36.65c0-7.244 4.687-13.124 13.488-16.988 7.27-3.19 16.907-4.773 27.088-4.476 10.062.294 19.374 2.387 26.265 5.873 8.193 4.146 12.491 9.97 12.491 16.876l-.195 35.02-.016.129c-1.006 8.226-5.636 16.727-13.819 25.325-6.563 6.896-13.981 12.36-19.074 15.746a10.758 10.758 0 0 1-5.651 1.803h-.001Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M176.516 100.807a10.141 10.141 0 0 1-5.613-1.483c-5.123-3.137-12.694-8.317-19.505-15.099-8.643-8.605-13.608-17.352-14.694-25.941l-.017-.135-.211-36.65c0-7.244 4.626-13.124 13.31-16.988 7.173-3.19 16.683-4.773 26.73-4.476 9.93.294 19.117 2.387 25.918 5.873 8.084 4.146 12.325 9.97 12.325 16.876l-.192 35.02-.015.129c-.993 8.226-5.562 16.727-13.636 25.325-6.478 6.896-13.797 12.36-18.823 15.746a10.52 10.52 0 0 1-5.577 1.803Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "m138.876 21.525.213 36.465c2.381 18.606 24.076 33.67 33.524 39.393 2.707 1.64 6.167 1.542 8.855-.24 9.251-6.136 29.758-21.583 31.949-39.472l.195-34.923c0-25.91-74.736-28.28-74.736-1.223Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M177.052 91.762a1.278 1.278 0 0 1-.7-.186c-3.89-2.375-11.432-7.348-17.993-13.844-7.086-7.016-11.174-13.838-12.111-20.244l-.209-35.862c.009-3.44 2.712-6.386 8.009-8.742 5.914-2.63 14.313-4.012 23.004-3.803 8.606.205 16.758 1.951 22.407 4.777 4.996 2.499 7.522 5.444 7.531 8.766l-.194 34.62c-.875 6.2-4.711 12.883-11.446 19.909-6.333 6.606-13.731 11.843-17.598 14.388a1.333 1.333 0 0 1-.7.22v.001Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M176.164 89.311c-3.929-2.44-10.916-7.148-17.011-13.194-6.66-6.606-10.514-12.946-11.42-18.812l-.207-35.653c.006-2.46 2.25-4.717 6.652-6.681 5.602-2.5 13.628-3.818 21.985-3.628 8.277.187 16.079 1.834 21.439 4.508 4.166 2.077 6.274 4.343 6.279 6.742l-.193 34.493c-.85 5.691-4.485 11.916-10.842 18.534-5.902 6.145-12.772 11.087-16.682 13.691Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "m190.222 42.63-26.456.238c-2.034.018-3.692 1.616-3.692 3.569V63.52c0 1.94 1.651 3.445 3.678 3.36l26.364-1.087c1.875-.078 3.396-1.642 3.405-3.496l.084-16.322a3.33 3.33 0 0 0-3.383-3.346Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M180.52 52.429c.006-1.887-1.601-3.379-3.562-3.254-1.738.11-3.179 1.524-3.276 3.221a3.217 3.217 0 0 0 1.706 3.036c.457.246.683.761.593 1.27l-.765 4.316c-.097.55.335 1.033.905 1.013l1.935-.069c.566-.02.996-.53.903-1.07l-.74-4.276c-.088-.51.173-1.016.632-1.294.997-.605 1.666-1.68 1.67-2.894h-.001Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M189.851 40.936a1.417 1.417 0 0 1-1.434-1.42l.016-3.722c.017-3.737-3.049-6.813-6.87-6.851l-8.636-.087c-3.954-.039-7.207 3.07-7.21 6.925l-.003 3.84c0 .815-.69 1.48-1.54 1.485-.853.006-1.545-.653-1.545-1.472l.002-3.855c.002-5.512 4.658-9.937 10.301-9.858l8.639.122c5.428.076 9.763 4.454 9.738 9.753l-.018 3.706a1.448 1.448 0 0 1-1.441 1.435h.001Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 11.015,
    x2: 158.389,
    y1: 98.457,
    y2: 98.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BA7CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 193.398,
    x2: 129.474,
    y1: 75.23,
    y2: -52.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0,
    x2: 242.384,
    y1: 161.249,
    y2: 161.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 220.142,
    x2: 197.104,
    y1: -2.768,
    y2: 19.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#180047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B306E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 157.783,
    x2: 118.265,
    y1: 70.144,
    y2: 135.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 2.398,
    x2: 161.703,
    y1: 99.512,
    y2: 99.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 146.039,
    x2: 206.989,
    y1: 50.411,
    y2: 50.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#180047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B306E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 175.704,
    x2: 175.704,
    y1: 89.311,
    y2: 11.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1BEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6064D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 195.928,
    x2: 170.554,
    y1: 18.718,
    y2: 65.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EAF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7EAF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 173.949,
    x2: 184.877,
    y1: 38.687,
    y2: 88.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6064D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7EAF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 188.685,
    x2: 163.311,
    y1: 14.768,
    y2: 61.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EAF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7EAF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfidentialite);
export default __webpack_public_path__ + "static/media/confidentialite.8de7b74c0492471e89450c533d5fb39f.svg";
export { ForwardRef as ReactComponent };